import { Route, Redirect } from 'react-router-dom';
import React from 'react';

import { hasAppSession } from '../commons/auth/session';

const Secure = ({ component: Component, handleAuthenticatedChange, ...rest }) => {
  if (!hasAppSession()) {
    return <Redirect to="/login" />;
  }

  return (
    <Route {...rest}>
      <Component {...rest} handleAuthenticatedChange={handleAuthenticatedChange} />
    </Route>
  );
};

export default Secure;
